import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider, SkeletonPage, SkeletonBodyText, Layout, Card, BlockStack } from '@shopify/polaris';
import { NavMenu } from '@shopify/app-bridge-react';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import HomePage from './pages/HomePage';
import { authFetch } from './lib/api';
export default function App() {
    const [status, setStatus] = useState('loading');
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await authFetch('/api/init');
                if (cancelled)
                    return;
                if (!res.ok) {
                    setError(`Initialization failed (${res.status})`);
                    setStatus('error');
                    return;
                }
                setStatus('ready');
            }
            catch (err) {
                if (cancelled)
                    return;
                // authFetch throws after it has already triggered a top-window reauth
                // redirect; in that case we stay on the skeleton and let the redirect
                // happen. Any other error surfaces to the user.
                const message = err instanceof Error ? err.message : String(err);
                if (message === 'Reauthorization required')
                    return;
                setError(message);
                setStatus('error');
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);
    return (_jsx(AppProvider, { i18n: enTranslations, children: status === 'ready' ? (_jsxs(BrowserRouter, { children: [_jsx(NavMenu, { children: _jsx("a", { href: "/", rel: "home", children: "Home" }) }), _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(HomePage, {}) }) })] })) : (_jsx(SkeletonPage, { primaryAction: true, children: _jsx(Layout, { children: _jsxs(Layout.Section, { children: [_jsx(Card, { children: _jsx(BlockStack, { gap: "400", children: _jsx(SkeletonBodyText, { lines: 3 }) }) }), status === 'error' && error && (_jsx("p", { style: { marginTop: 16, color: 'var(--p-color-text-critical)' }, children: error }))] }) }) })) }));
}
